'use client';

import { TextField, BlockStack, InlineStack } from '@shopify/polaris';
import { StandaloneMediaAsset } from '@/types/media';
import MediaAssetCard from '../media-asset/MediaAssetCard';

interface TextToImageProps {
  generatedMediaAsset?: StandaloneMediaAsset;
  prompt: string;
  setPrompt: (prompt: string) => void;
  isGenerating: boolean;
  isError: boolean;
  hideUseAction?: boolean;
  multiline?: number;
  maxHeight?: string;
}

export default function TextToImage({
  generatedMediaAsset,
  prompt,
  setPrompt,
  isGenerating,
  isError,
  hideUseAction = false,
  multiline = 4,
  maxHeight = '100px',
}: TextToImageProps) {
  return (
    <BlockStack gap="600">
      <TextField
        label="Prompt"
        labelHidden
        value={prompt}
        onChange={setPrompt}
        autoComplete="off"
        placeholder="Enter a prompt..."
        disabled={isGenerating}
        multiline={multiline}
        maxHeight={maxHeight}
      />

      {!isError && generatedMediaAsset && (
        <InlineStack align="center">
          <MediaAssetCard media={generatedMediaAsset} hideUseAction={hideUseAction} />
        </InlineStack>
      )}
    </BlockStack>
  );
}
